import { makeObservable, observable, action } from 'mobx';
import { notificationStore } from '../notificationStore.js';
import '../../enums/GameSpecificTypes.js';
import '../../enums/MaxPayoutDataTypes.js';
import '../../enums/Chat.js';
import '../../enums/GameModes.js';
import '../../enums/IconTypes.js';
import '../../enums/BetStatus.js';
import '../../enums/PopupTypes.js';
import '../../enums/ApiVersion.js';
import '../../enums/RoundStatus.js';
import '../../enums/FreeBetsStatus.js';
import '../../enums/SocketEvents.js';
import '../../enums/TranslationKeys.js';
import '../../enums/TimeoutMaxValue.js';
import '../../enums/ApiServiceTypes.js';
import '../../enums/EnvironmentTypes.js';
import '../../enums/DefaultQueryValues.js';
import '../../enums/FreeBetWinningType.js';
import '../../enums/DefaultQueryParams.js';
import '../../enums/BetHistoryFilterTypes.js';
import '../../enums/GameThemeTypes.js';
import '../../enums/RequestStatus.js';
import '../../enums/FetchDefaultPaths.js';
import '../../enums/ResponseCodes.js';
import { betSectionIndex } from '../../enums/BogLineGameConfig.js';

var InputValidation = /** @class */ (function () {
    function InputValidation() {
        this.validationSections = [
            {
                index: betSectionIndex.firstIndex,
                isClosedDoBet: false,
            },
            {
                index: betSectionIndex.secondIndex,
                isClosedDoBet: false,
            },
        ];
        this.isClosedAutoBet = false;
        this.dynamicValidationType = {};
        makeObservable(this, {
            validationSections: observable.deep,
            isClosedAutoBet: observable,
            dynamicValidationType: observable,
            setDefaultValue: action,
            setDefaultValueNumpad: action,
            setDynamicValidationType: action,
            handleCloseDoBet: action.bound,
        });
    }
    InputValidation.prototype.setDynamicValidationType = function (type, value) {
        var _a;
        this.dynamicValidationType = (_a = {}, _a[type] = [value], _a);
    };
    InputValidation.prototype.handleCloseDoBet = function (bool, index) {
        if (index !== betSectionIndex.secondIndex && index !== betSectionIndex.firstIndex) {
            this.isClosedAutoBet = bool;
        }
        else {
            this.validationSections.forEach(function (item) {
                if (item.index === index) {
                    item.isClosedDoBet = bool;
                }
            });
        }
    };
    InputValidation.prototype.setDefaultValue = function (value, action, limits, betSectionIndex, responseType) {
        var _this = this;
        var maxValue = limits.maxValue, minValue = limits.minValue;
        var currentValue = +value;
        if (currentValue < minValue) {
            action(minValue, betSectionIndex);
            this.handleCloseDoBet(true, betSectionIndex);
            notificationStore.setNotificationType({
                responseCode: responseType.minOdd,
            });
            setTimeout(function () { return _this.handleCloseDoBet(false, betSectionIndex); }, 1000);
        }
        if (maxValue && currentValue > maxValue) {
            action(maxValue, betSectionIndex);
            this.handleCloseDoBet(true, betSectionIndex);
            notificationStore.setNotificationType({
                responseCode: responseType.maxOdd,
            });
            setTimeout(function () { return _this.handleCloseDoBet(false, betSectionIndex); }, 100);
        }
    };
    // setDefaultValue(value, action, limits, betSectionIndex, responseType) {
    //   const { maxValue, minValue } = limits;
    //   const currentValue = +value;
    //   if (currentValue < minValue) {
    //     this.setDynamicValidationType(responseType.InValidMin, minValue);
    //     if (betSectionIndex || betSectionIndex === 0) {
    //       action(minValue, betSectionIndex);
    //     } else {
    //       action(minValue);
    //     }
    //     this.handleCloseDoBet(true, betSectionIndex);
    //     notificationStore.setNotificationType({
    //       responseCode: responseType.InValidMin,
    //     });
    //     setTimeout(() => this.handleCloseDoBet(false, betSectionIndex), 1000);
    //   }
    //   if (maxValue && currentValue > maxValue) {
    //     this.setDynamicValidationType(responseType.InValidMax, maxValue);
    //     if (betSectionIndex || betSectionIndex === 0) {
    //       action(maxValue, betSectionIndex);
    //     } else {
    //       action(maxValue);
    //     }
    //     this.handleCloseDoBet(true, betSectionIndex);
    //     notificationStore.setNotificationType({
    //       responseCode: responseType.InValidMax,
    //     });
    //     setTimeout(() => this.handleCloseDoBet(false, betSectionIndex), 100);
    //   }
    // }
    InputValidation.prototype.setDefaultValueNumpad = function (value, action, limits, betSectionIndex, responseType) {
        var minValue = limits.minValue, maxValue = limits.maxValue;
        var currentValue = +value;
        if (currentValue < minValue) {
            this.setDynamicValidationType(responseType.InValidMin, minValue);
            if (betSectionIndex || betSectionIndex === 0) {
                action(minValue, betSectionIndex);
            }
            else {
                action(minValue);
            }
            notificationStore.setNotificationType({
                responseCode: responseType.invalidMin,
            });
        }
        else if (maxValue && currentValue > maxValue) {
            if (betSectionIndex || betSectionIndex === 0) {
                action(maxValue, betSectionIndex);
            }
            else {
                action(maxValue);
            }
            notificationStore.setNotificationType({
                responseCode: responseType.invalidMax,
            });
        }
        else if (betSectionIndex || betSectionIndex === 0) {
            action(currentValue, betSectionIndex);
        }
        else {
            action(currentValue);
        }
    };
    return InputValidation;
}());
var inputValidationStore = new InputValidation();

export { inputValidationStore };
